module.exports = __webpack_public_path__ + "img/dashboard.dc02d644.svg";